
<div class="card">
    <div class="card-header">
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-10 order-md-first text-lg-start d-flex justify-content">
                <a style="margin: 9px;" class="btn bg-danger-custom" id="contact" routerLink="/merchants/merchant-master"><i class="feather icon-arrow-left"></i>Back</a>
                <h4 class="mb-3 mt-3" >{{'Merchant/Agent On-Boarding'}}</h4>
                <ng-template #ifNotShow><h4 class="mb-3 mt-3">{{'Merchant/Agent On-Boarding' }}</h4></ng-template>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12 grid-margin">
        <div class="card p-2">
            <div class="card-body">
            <aw-wizard #wizardForm [awNavigationMode]="navigationMode">
            <aw-wizard-step stepTitle="Contact Details">
            <form #onboard="ngForm" (ngSubmit)="form1Submit(onboard.value)" [formGroup]="validationForm1">
            <hr>
            <div class="row">
                <div class="col-sm-4">
                    <label class="col-form-label" for="userType">Entity Type <span aria-hidden="true"
                                                                                       class="symbol required"
                                                                                       style="color:red;">*</span></label>
                      <ng-select placeholder="Select Entity Type" name="userType"(change)="enableParentAgent()" [ngClass]="{'is-invalid': isForm1Submitted && form1.userType.errors}" formControlName="userType" >
                        <!-- <option value=null >Select Agent Type</option> -->
                        <ng-option value="Merchant">Merchant</ng-option>
                        <ng-option value="Agent">Agent</ng-option>
                        <ng-option value="SubAgent">Sub Agent</ng-option>
                      </ng-select>
                      <div  class="invalid-feedback">
                        Please Select Entity Type
                      </div>
                  </div>
                  <div class="col-sm-4" *ngIf="display">
                    <label class="col-form-label" for="parentAgent">Parent Agent <span aria-hidden="true"
                                                                                           class="symbol required"
                                                                                           style="color:red;">*</span></label>
                      <ng-select placeholder="Select Parent Entity" type="text" name="parentAgent" formControlName="parentAgent" ngModel >
                        <option value=null disabled>Select Parent Agent</option>
                        <ng-option *ngFor="let user of parentList" value={{user.id}}>
                          {{user.name}}
                        </ng-option>

                      </ng-select>
                      <div *ngIf="isForm1Submitted && form1.parentAgent.errors?.required" class="invalid-feedback">
                        Please Select Parent Agent
                      </div>
                  </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                  <label class="col-form-label" for="contactName">Contact Name <span aria-hidden="true"
                                                                                     class="symbol required"
                                                                                     style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactName.errors}" class="form-control"
                           formControlName="contactName" id="contactName" placeholder="Contact Name" type="text"
                           autocomplete="new-password"
                           maxlength="200" pattern="[a-zA-Z][a-zA-Z ]+">
                    <div *ngIf="isForm1Submitted && form1.contactName.errors?.required" class="invalid-feedback">
                      Please enter Contact Name
                    </div>
                    <div *ngIf="isForm1Submitted && form1.contactName.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Name
                    </div>
                    <div *ngIf="isForm1Submitted && form1.contactName.errors?.twoSpaces" class="invalid-feedback">
                      More than two consecutive spaces are not allowed
                    </div>
                </div>
                <div class="col-sm-4">
                  <label class="col-form-label" for="contactNumber">Contact Number <span aria-hidden="true"
                                                                                         class="symbol required"
                                                                                         style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                           class="form-control" formControlName="contactNumber" id="contactNumber"
                           placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                           autocomplete="new-password"
                           minlength="9"
                           maxlength="10" pattern="[0-9 ]{10}">
                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                      Please enter Contact Number
                    </div>

                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Number
                    </div>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="emailId">Email Id <span aria-hidden="true" class="symbol required"
                                                                               style="color:red;">*</span></label>
                      <input [ngClass]="{'is-invalid': isForm1Submitted && form1.emailId.errors}" class="form-control"
                             formControlName="emailId" id="emailId" placeholder="sample@Global.in"
                             autocomplete="new-password" type="email"
                             maxlength="50">
                      <div *ngIf="isForm1Submitted && form1.emailId.errors?.required" class="invalid-feedback">
                        Please Enter  Email Id
                      </div>

                      <!-- <div *ngIf="!mindatadis && emailError" class="text-danger mt-1 err">
                        {{ emailError }}
                      </div> -->

                      <!-- <div *ngIf="isForm1Submitted && form1.emailId.errors?.email" class="invalid-feedback">
                        Please provide valid Email
                      </div> -->
                      <div *ngIf="isForm1Submitted && (form1.emailId.errors?.pattern||form1.emailId.errors?.email)"
                           class="invalid-feedback">
                        Please Enter valid Email
                      </div>
                  </div>

            </div>
            <div class="row mt-4">
                <div class="col-sm-12 text-right">
                    <button class="btn btn-primary" type="submit">Save & Next</button>
                </div>
            </div>
            </form>
            </aw-wizard-step>
<!--
            <aw-wizard-step stepTitle="Business Details">
                <hr>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Commercial License Number<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                          <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                                 class="form-control" formControlName="contactNumber" id="contactNumber"
                                 placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                                 autocomplete="new-password"
                                 minlength="9"
                                 maxlength="10" pattern="[0-9 ]{10}">
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                      <div class="col-sm-4">
                  <label class="col-form-label" for="contactNumber">Legal Name<span aria-hidden="true"
                                                                                         class="symbol required"
                                                                                         style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                           class="form-control" formControlName="contactNumber" id="contactNumber"
                           placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                           autocomplete="new-password"
                           minlength="9"
                           maxlength="10" pattern="[0-9 ]{10}">
                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                      Please enter Contact Number
                    </div>

                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Number
                    </div>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="contactNumber">Trade Name<span aria-hidden="true"
                                                                                           class="symbol required"
                                                                                           style="color:red;">*</span></label>
                      <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                             class="form-control" formControlName="contactNumber" id="contactNumber"
                             placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                             autocomplete="new-password"
                             minlength="9"
                             maxlength="10" pattern="[0-9 ]{10}">
                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                        Please enter Contact Number
                      </div>

                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                        Please enter Valid Contact Number
                      </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Business Type<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                          <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                                 class="form-control" formControlName="contactNumber" id="contactNumber"
                                 placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                                 autocomplete="new-password"
                                 minlength="9"
                                 maxlength="10" pattern="[0-9 ]{10}">
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                      <div class="col-sm-4">
                  <label class="col-form-label" for="contactNumber">Authorized Person EID<span aria-hidden="true"
                                                                                         class="symbol required"
                                                                                         style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                           class="form-control" formControlName="contactNumber" id="contactNumber"
                           placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                           autocomplete="new-password"
                           minlength="9"
                           maxlength="10" pattern="[0-9 ]{10}">
                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                      Please enter Contact Number
                    </div>

                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Number
                    </div>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="contactNumber">Authorized Person EID Name<span aria-hidden="true"
                                                                                           class="symbol required"
                                                                                           style="color:red;">*</span></label>
                      <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                             class="form-control" formControlName="contactNumber" id="contactNumber"
                             placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                             autocomplete="new-password"
                             minlength="9"
                             maxlength="10" pattern="[0-9 ]{10}">
                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                        Please enter Contact Number
                      </div>

                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                        Please enter Valid Contact Number
                      </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Address<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                          <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                                 class="form-control" formControlName="contactNumber" id="contactNumber"
                                 placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                                 autocomplete="new-password"
                                 minlength="9"
                                 maxlength="10" pattern="[0-9 ]{10}">
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                      <div class="col-sm-4">
                  <label class="col-form-label" for="contactNumber">City<span aria-hidden="true"
                                                                                         class="symbol required"
                                                                                         style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                           class="form-control" formControlName="contactNumber" id="contactNumber"
                           placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                           autocomplete="new-password"
                           minlength="9"
                           maxlength="10" pattern="[0-9 ]{10}">
                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                      Please enter Contact Number
                    </div>

                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Number
                    </div>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="contactNumber">P. O. Box<span aria-hidden="true"
                                                                                           class="symbol required"
                                                                                           style="color:red;">*</span></label>
                      <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                             class="form-control" formControlName="contactNumber" id="contactNumber"
                             placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                             autocomplete="new-password"
                             minlength="9"
                             maxlength="10" pattern="[0-9 ]{10}">
                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                        Please enter Contact Number
                      </div>

                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                        Please enter Valid Contact Number
                      </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Emirate<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                          <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                                 class="form-control" formControlName="contactNumber" id="contactNumber"
                                 placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                                 autocomplete="new-password"
                                 minlength="9"
                                 maxlength="10" pattern="[0-9 ]{10}">
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                      <div class="col-sm-4">
                  <label class="col-form-label" for="contactNumber">Establishment Card Number<span aria-hidden="true"
                                                                                         class="symbol required"
                                                                                         style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                           class="form-control" formControlName="contactNumber" id="contactNumber"
                           placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                           autocomplete="new-password"
                           minlength="9"
                           maxlength="10" pattern="[0-9 ]{10}">
                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                      Please enter Contact Number
                    </div>

                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Number
                    </div>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="contactNumber">Establishment Card Expiry Date<span aria-hidden="true"
                                                                                           class="symbol required"
                                                                                           style="color:red;">*</span></label>
                      <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                             class="form-control" formControlName="contactNumber" id="contactNumber"
                             placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                             autocomplete="new-password"
                             minlength="9"
                             maxlength="10" pattern="[0-9 ]{10}">
                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                        Please enter Contact Number
                      </div>

                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                        Please enter Valid Contact Number
                      </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Registration Number<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                          <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                                 class="form-control" formControlName="contactNumber" id="contactNumber"
                                 placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                                 autocomplete="new-password"
                                 minlength="9"
                                 maxlength="10" pattern="[0-9 ]{10}">
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                      <div class="col-sm-4">
                  <label class="col-form-label" for="contactNumber">Registration Date<span aria-hidden="true"
                                                                                         class="symbol required"
                                                                                         style="color:red;">*</span></label>
                    <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                           class="form-control" formControlName="contactNumber" id="contactNumber"
                           placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                           autocomplete="new-password"
                           minlength="9"
                           maxlength="10" pattern="[0-9 ]{10}">
                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                      Please enter Contact Number
                    </div>

                    <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                      Please enter Valid Contact Number
                    </div>
                </div>
                <div class="col-sm-4">
                    <label class="col-form-label" for="contactNumber">Registration Expiry Date<span aria-hidden="true"
                                                                                           class="symbol required"
                                                                                           style="color:red;">*</span></label>
                      <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                             class="form-control" formControlName="contactNumber" id="contactNumber"
                             placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                             autocomplete="new-password"
                             minlength="9"
                             maxlength="10" pattern="[0-9 ]{10}">
                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                        Please enter Contact Number
                      </div>

                      <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                        Please enter Valid Contact Number
                      </div>
                  </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Website<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                          <input [ngClass]="{'is-invalid': isForm1Submitted && form1.contactNumber.errors}"
                                 class="form-control" formControlName="contactNumber" id="contactNumber"
                                 placeholder="Contact Number" (keypress)="OnlyNumbersAllowed($event)" type="text"
                                 autocomplete="new-password"
                                 minlength="9"
                                 maxlength="10" pattern="[0-9 ]{10}">
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 text-right">
                        <button class="btn btn-secondary" (click)="form2Submit()">Back</button>
                        <button class="btn btn-primary" (click)="form2Submit()">Save & Next</button>
                    </div>
                </div>
            </aw-wizard-step>
            <aw-wizard-step stepTitle="Questionnaire">
                <hr>
                <div class="row mt-4" *ngFor="let question of questionList; let i = index">
                    <div *ngIf="question.subQuestion.length != 0">
                        <div class="form-group col-md-10">
                            <h5>{{i+1}}. {{question.question}}</h5>
                        </div>
                        <div class="row d-flex" *ngFor="let subQuestionData of question.subQuestion; let j = index">
                            <div class="d-flex">
                                <div class="form-group col-md-10">
                                    <p>{{alpha[j]}}. {{subQuestionData.question}}</p>
                                </div>
                                <div class="form-group col-md-1" >
                                    <input class="form-check-input" type="radio"  name="nshRadio{{alpha[j]+subQuestionData.id}}" value="relavent" autocomplete="off" (change)="yesSubCheckBox($event,i,j)">
                                    <label class=" col-form-label form-check-label" style="margin-left: 5px;  margin-top: -5px;"> Yes</label>
                                </div>
                                <div class="form-group col-md-1" >
                                    <input class="form-check-input" type="radio"  name="nshRadio{{alpha[j]+subQuestionData.id}}" value="nonRelavent" autocomplete="off" (change)="noSubCheckBox($event,i,j)">
                                    <label class=" col-form-label form-check-label" style="margin-left: 5px; margin-top: -5px;"> No</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-12" *ngIf="question.isTextField">
                             <label class="col-form-label">{{question.description}}</label>
                            <textarea class="form-control" rows="3" [placeholder]="question.description" maxlength="200"></textarea>
                        </div>
                    </div>
                    <div *ngIf="question.subQuestion.length == 0">
                            <div class="d-flex">
                                <div class="form-group col-md-10">
                                    <h5>{{i+1}}. {{question.question}}</h5>
                                </div>
                                <div class="form-group col-md-1" >
                                    <input class="form-check-input" type="radio"  name="nshRadio{{i}}" value="relavent" autocomplete="off" (change)="yesCheckBox($event,i)">
                                    <input class="form-check-input" type="radio"  (change)="yesCheckBox($event,i)">
                                    <label class=" col-form-label form-check-label"  style="margin-left: 5px; margin-top: -5px;" > Yes</label>
                                </div>
                                <div class="form-group col-md-1" >
                                    <input class="form-check-input" type="radio"  name="nshRadio{{i}}" value="nonRelavent" autocomplete="off" (change)="noCheckBox($event,i)">
                                     <input class="form-check-input" type="radio"  (change)="noCheckBox($event,i)">
                                    <label class=" col-form-label form-check-label"  style="margin-left: 5px; margin-top: -5px;"> No</label>
                                </div>
                            </div>
                            <div class="form-group col-md-12" *ngIf="question.isTextField">
                                 <label class="col-form-label">{{question.description}}</label>
                                <textarea class="form-control" rows="3" [placeholder]="question.description" maxlength="200"></textarea>
                            </div>
                    </div>
                    <br>
                    <hr>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 text-right">
                            <button class="btn btn-primary" (click)="form3Submit()">Save & Next</button>
                    </div>
                </div>
            </aw-wizard-step>
            <aw-wizard-step stepTitle="Product Offerings">
                <hr>
                <div class="row">
                    <div class="col-sm-4">
                        <label class="col-form-label" for="contactNumber">Product<span aria-hidden="true"
                                                                                               class="symbol required"
                                                                                               style="color:red;">*</span></label>
                        <ng-select placeholder="Select Product" [multiple]="true" name="userType"(change)="enableParentAgent()">
                                                                                                 <option value=null >Select Agent Type</option>
                            <ng-option value="qr">QR Payments</ng-option>
                            <ng-option value="agent">Agent service</ng-option>
                            <ng-option value="pos">Tap on Phone (POS)</ng-option>
                            <ng-option value="pg">Payment gateway</ng-option>
                        </ng-select>
                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.required" class="invalid-feedback">
                            Please enter Contact Number
                          </div>

                          <div *ngIf="isForm1Submitted && form1.contactNumber.errors?.pattern" class="invalid-feedback">
                            Please enter Valid Contact Number
                          </div>
                      </div>
                </div>
                <div class="row mt-4">
                    <div class="col-sm-12 text-right">
                            <button class="btn btn-primary" (click)="form4Submit()">Save & Next</button>
                    </div>
                </div>
            </aw-wizard-step>
            <aw-wizard-step stepTitle="Finish">
                <hr>
                <div class="row mt-4">
                    <div class="col-sm-12 text-right">
                            <button class="btn btn-primary" (click)="form5Submit()">Submit</button>
                    </div>
                </div>
            </aw-wizard-step> -->
            </aw-wizard>
            </div>
        </div>
        </div>
    </div>
</div>
